<template>
  <div>
    <a-card :bordered="false" title="卡密管理">
      <a slot="extra" @click="handleHelp">
        <a-icon type="question-circle" />
      </a>
      <div class="card-container">
        <div class="spread">
          <lottie :options="animationData.property2" :height="100" :width="100"></lottie>
        </div>
        <div>
          <a-statistic title="剩余可用 (个)" :value="totalCount" />
          <div class="btns">
            <a-button
              disabled
              class="item"
              type="primary"
              size="small"
              @click="$refs.exchangeModal.show()"
            >兑换</a-button>
            <a-button class="item" type="default" size="small" @click="$refs.billModal.show()">卡密仓库</a-button>
          </div>
        </div>
      </div>
    </a-card>
    <exchange-modal ref="exchangeModal" @ok="handleExchangeOk"></exchange-modal>
    <bill-modal ref="billModal"></bill-modal>
  </div>
</template>

<script>
import Lottie from '@/common/Lottie/lottie.vue'
import * as animationData2 from '@/assets/lottie/property@2.json'
import ExchangeModal from './ExchangeModal'
import BillModal from './BillModal'
import PropertyCardApi from '@/api/property-card'
export default {
  components: {
    Lottie,
    ExchangeModal,
    BillModal
  },
  data() {
    return {
      animationData: {
        property2: { animationData: animationData2 }
      },
      totalCount: 0
    }
  },
  computed: {},
  filters: {},
  created() {
    this.getData()
  },
  methods: {
    handleHelp() {
      this.$info({
        title: '充值卡说明',
        content: (
          <div>
            <p>1.充值卡可以用于对机器人期限续费</p>
          </div>
        )
      })
    },
    handleExchangeOk() {
      this.getData()
      this.$emit('ok')
    },
    getData() {
      PropertyCardApi.getList({
        card_status: 0
      }).then(res => {
        this.totalCount = res.totalCount
      })
    }
  }
}
</script>
<style lang="less" scoped>
.card-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  .btns {
    margin: 5px 0;
    .item {
      margin-right: 5px;
    }
  }
}
</style>
